export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";
export const SUBSCRIPTION_DATA_RECEIVED = "SUBSCRIPTION_DATA_RECEIVED";
export const ADD_CONTEXT = "ADD_CONTEXT";
export const UPDATE_CONTEXT = "UPDATE_CONTEXT";
export const UPDATE_CONTEXT_PROPERTY = "UPDATE_CONTEXT_PROPERTY";
export const REMOVE_CONTEXT = "REMOVE_CONTEXT";
export const REMOVE_SUBSCRIPTION = "REMOVE_SUBSCRIPTION";
export const REMOVE_SUBSCRIBER = "REMOVE_SUBSCRIBER";
export const ADD_SUBSCRIBER = "ADD_SUBSCRIBER";
export const UPDATE_CONTEXT_LIST_CATEGORIES = "UPDATE_CONTEXT_LIST_CATEGORIES";
export const UPDATE_CONTEXT_PROPERTY_WITH_DOT_NOTATION = "UPDATE_CONTEXT_PROPERTY_WITH_DOT_NOTATION";
export const ALERT_OCCURRENCES_PAGE_REQUESTED = "ALERT_OCCURRENCES_PAGE_REQUESTED";
export const ALERT_OCCURRENCES_PAGE_RECEIVED = "ALERT_OCCURRENCES_PAGE_RECEIVED";
export const ALERT_OCCURRENCES_PAGE_FAILED = "ALERT_OCCURRENCES_PAGE_FAILED";
export const ALERT_OCCURRENCE_BATCH_RECEIVED = "ALERT_OCCURRENCE_BATCH_RECEIVED";
export const CLEAR_ALERT_OCCURRENCES = "CLEAR_ALERT_OCCURRENCES";
